import { FranchiseAgreementAcceptance } from "@hubcapp/graphql/types/gateway";
import { formatCurrency } from "@ds-developer/frontend";
import { getSafeDate } from "@hubcapp/utils";
import { makeStyles } from "@material-ui/core";
import React from "react";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  subText: {
    fontWeight: 400,
    "&.bsm": {
      fontWeight: 300,
    },
    fontSize: "18px",
    lineHeight: "27px",
    color: "#2B2D32",
  },
  sectionStyle: {
    marginBottom: "114px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "60px",
    },
  },
  [theme.breakpoints.down("sm")]: {
    subText: {
      fontSize: "16px",
    },
  },
  title: {
    fontWeight: 700,
    "&.bsm": {
      fontWeight: 500,
    },
    fontSize: "18px",
    lineHeight: "27px",
    color: "#2B2929",
    padding: "6px 50px 6px 0px",
    [theme.breakpoints.down("sm")]: {
      padding: "6px 6px 6px 0px",
    },
  },
  result: {
    fontWeight: 400,
    "&.bsm": {
      fontWeight: 300,
    },
    fontSize: "18px",
    lineHeight: "27px",
    color: "#2B2929",
  },
}));

type Props = {
  data: FranchiseAgreementAcceptance | undefined;
};

const FranchiseDetailsComponent: React.FC<Props> = ({ data }) => {
  const classes = useStyles();
  const brand = data?.brand || "BSM";
  if (!data) return null;
  const arrayFormFranchiseName = data?.franchiseName?.split(" ");
  return (
    <div className={classes.sectionStyle}>
      <p
        className={clsx(classes.subText, {
          bsm: brand === "BSM",
        })}
      >
        Here are your franchise details, if something doesn&apos;t seem right
        please contact the team on&nbsp;
        {brand === "BSM" ? "0330 100 7509" : "0330 053 0007"}.
      </p>
      <div>
        <table>
          <tr>
            <td
              className={clsx(classes.title, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              Franchise type
            </td>
            <td
              className={clsx(classes.result, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              {arrayFormFranchiseName?.slice(0, 2)?.join(" ") ?? " "}
            </td>
          </tr>
          <tr>
            <td
              className={clsx(classes.title, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              Vehicle
            </td>
            <td
              className={clsx(classes.result, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              {arrayFormFranchiseName?.slice(2, -2)?.join(" ") ?? " "}
            </td>
          </tr>
          <tr>
            <td
              className={clsx(classes.title, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              Duration
            </td>
            <td
              className={clsx(classes.result, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              {data?.duration == 1
                ? `${data?.duration} month`
                : `${data?.duration} months`}
            </td>
          </tr>
          {data?.leadType === "DIT" && (
            <tr>
              <td
                className={clsx(classes.title, {
                  bsm: brand === "BSM",
                  aa: brand !== "BSM",
                })}
              >
                Course payment instalments
              </td>
              <td
                className={clsx(classes.result, {
                  bsm: brand === "BSM",
                  aa: brand !== "BSM",
                })}
              ></td>
            </tr>
          )}
          <tr>
            <td
              className={clsx(classes.title, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              Preferred start date
            </td>
            <td
              className={clsx(classes.result, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              {getSafeDate(data?.startDateTime)}
            </td>
          </tr>
          <tr>
            <td
              className={clsx(classes.title, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              Payment type
            </td>
            <td
              className={clsx(classes.result, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              {data?.paymentType || "TODO"}
            </td>
          </tr>
          <tr>
            <td
              className={clsx(classes.title, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              Minimum payment term
            </td>
            <td
              className={clsx(classes.result, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              {data?.paymentTerms}
            </td>
          </tr>
          <tr>
            <td
              className={clsx(classes.title, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              Total payable
            </td>
            <td
              className={clsx(classes.result, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              {formatCurrency(data?.totalPayable || 0, false, {
                displayDecimalValue: true,
              })}
            </td>
          </tr>
          <tr>
            <td
              className={clsx(classes.title, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              Payment due weekly
            </td>
            <td
              className={clsx(classes.result, {
                bsm: brand === "BSM",
                aa: brand !== "BSM",
              })}
            >
              {formatCurrency(data?.paymentDueWeekly || 0, false, {
                displayDecimalValue: true,
              })}
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default FranchiseDetailsComponent;
